import {
    httpPost, httpGet
} from "/config/request.js"

// 激活用户
export function membActive(params) {
    return httpPost('memb/membInfo/membActive', params)
}
// 查询会员信息
export function getMembInfoById2ObjApi(params) {
    return httpPost('/memb/membInfo/getMembInfoById2Obj', params)
}
// 校验会员状态
export function checkOutMembInfoApi(params) {
    return httpPost('/memb/membInfo/checkOutMembInfo', params)
}
export function getMembInfoForIntroduce(params) {
    return httpPost('/memb/membInfo/getMembInfoForIntroduce', params)
}
export function getMembByUserNameAndPasswordApi(params) {
    return httpPost('/memb/membInfo/getMembByUserNameAndPassword', params)
}
export function getMembInfoByOpenId(params) {
    return httpPost('/memb/membInfo/getMembInfoByOpenId', params)
}
export function confirmChangePasswordApi(params) {
    return httpPost('/memb/membInfo/confirmChangePassword', params)
}
export function createMemb(params) {
    return httpPost('/memb/membInfo/createMemb', params)
}
export function submitPersonalInfo(params) {
    return httpPost('/memb/membInfo/submitPersonalInfo', params)
}
export function getMembInfoByIdApi(params) {
    return httpPost('/memb/membInfo/getMembInfoById', params)
}
export function updateNickNameApi(params) {
    return httpPost('/memb/membInfo/updateNickNameByMembId', params)
}
export function updatePhoneNumApi(params) {
    return httpPost('/memb/membInfo/editPhoneNum', params)
}
export function updateMembInfoByMembIdApi(params) {
    return httpPost('/memb/membInfo/updateMembInfoByMembId', params)
}
export function selVerificationByMembIdApi(params) {
    return httpPost('/memb/MembIdentityVerification/selVerificationByMembId', params)
}
export function authenticationByIdentityCardOrPhoneApi(params) {
    return httpPost('/memb/membInfo/authenticationByIdentityCardOrPhone', params)
}
export function getBaseSystemSetInfoByPlatIdApi(params) {
    return httpPost('/base/baseRuleSet/getBaseSystemSetInfoByPlatId', params)
}
export function findPushPersonCountApi(params) {
    return httpPost('/memb/membInfo/findPushPersonCount', params)
}
export function checkIntroduceMembNumAndNodeMembNumApi(params) {
    return httpPost('/memb/membInfo/checkIntroduceMembNumAndNodeMembNum', params)
}


// 赠送积分
export function updateAccountLaveByMembId(params) {
    return httpPost('/memb/membInfo/updateAccountLaveByMembId', params)
}